/**
 * i18n module exports
 */

import { SUPPORTED_LANGUAGES } from './config';

export {
  default as i18n,
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
  changeLanguage,
  persistKnownLanguage,
  readKnownLanguageCookie,
  clearKnownLanguageCookie,
  LANGUAGE_STORAGE_KEY,
} from './config';
export type { SupportedLanguageCode } from './config';
export { useApplyChallengeLanguage } from './useApplyChallengeLanguage';

/**
 * Get the direction (ltr/rtl) for a language code
 */
export function getLanguageDirection(code: string): 'ltr' | 'rtl' {
  const lang = SUPPORTED_LANGUAGES.find(l => l.code === code);
  return lang?.dir ?? 'ltr';
}

/**
 * Get language info by code
 */
export function getLanguageInfo(code: string) {
  return SUPPORTED_LANGUAGES.find(l => l.code === code);
}
